'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp; /* eslint-disable */

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _auth = require('redux/modules/auth');

var authActions = _interopRequireWildcard(_auth);

var _register = require('redux/modules/register');

var registerActions = _interopRequireWildcard(_register);

var _reactBootstrap = require('react-bootstrap');

var ReactBootstrap = _interopRequireWildcard(_reactBootstrap);

var _reactRouterBootstrap = require('react-router-bootstrap');

var _components = require('components');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// connects part of the state to the component?
var Register = (_dec = (0, _reactRedux.connect)(function (state) {
  return { user: state.auth.user };
}, registerActions), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(Register, _Component);

  function Register() {
    (0, _classCallCheck3.default)(this, Register);
    return (0, _possibleConstructorReturn3.default)(this, (Register.__proto__ || (0, _getPrototypeOf2.default)(Register)).apply(this, arguments));
  }

  (0, _createClass3.default)(Register, [{
    key: 'handleSubmit',


    /***** HANDLE USER CLICK REGISTER *****/

    value: function handleSubmit(username, email, firstname, lastname, gender, password) {
      console.log('Received: ' + username + ' ' + email + ' ' + firstname + ' ' + lastname + ' ' + gender + ' ' + password);

      // this.props.register(username, email, firstname, lastname, gender, password);
    }

    /***** END HANDLE USER CLICK REGISTER *****/

    /***** RENDER *****/

    // when you define your data models
    // there are properties they take in

  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          user = _props.user,
          logout = _props.logout;

      var styles = require('./Register.scss');

      return _react2.default.createElement(
        'div',
        { className: styles.registerPage },
        _react2.default.createElement(_reactHelmet2.default, { title: 'Register' }),
        _react2.default.createElement(
          'div',
          { className: styles.header },
          _react2.default.createElement(_components.RegistrationForm, { submit: this.handleSubmit })
        )
      );
    }
  }]);
  return Register;
}(_react.Component), _class2.propTypes = {
  user: _react.PropTypes.object,
  login: _react.PropTypes.func,
  logout: _react.PropTypes.func,
  register: _react.PropTypes.func
}, _temp)) || _class);

/* eslint-enable */

exports.default = Register;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Register/Register.js
// module id = 1287
// module chunks = 0